import './bootstrap';

function getNavbarHeight() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'));
}

function showRecaptchaBadge(show) {
    var badge = document.querySelector('.grecaptcha-badge');
    if (badge) {
        badge.style.visibility = show ? 'visible' : 'hidden';
    }
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight && rect.bottom > 0
  );
}

document.addEventListener('scroll', function() {
  const navbarHeight = getNavbarHeight();
  const hero = document.querySelector('.hero-section');
  const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
  const heroRect = hero.getBoundingClientRect();
  // If hero is at least partially visible at top of viewport
  if (heroRect.top <= 0 && heroRect.bottom > navbarHeight) {
    navLinks.forEach(link => link.classList.remove('active'));
  }

  const contactSection = document.getElementById('contact');
  if (contactSection && isElementInViewport(contactSection)) {
        showRecaptchaBadge(true);
    } else {
        showRecaptchaBadge(false);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // const navbar = document.querySelector('.navbar');
    const navbarHeight = getNavbarHeight();

    // Navbar scrolled style
    function onScroll() {
        if (window.scrollY > 30) {
            document.body.classList.add('scrolled');
        } else {
            document.body.classList.remove('scrolled');
        }
    }
    window.addEventListener('scroll', onScroll);
    window.addEventListener('load', onScroll);

    // Set sessionStorage flag on contact form submit
    // const contactForm = document.getElementById('contact-form');
    // if (contactForm) {
    //     contactForm.addEventListener('submit', function(e) {
    //         if (!document.getElementById('recaptcha_token').value) {
    //             e.preventDefault();
    //             alert('Please wait for reCAPTCHA to load.');
    //         } else {
    //             sessionStorage.setItem('scrollToContact', '1');
    //         }
    //     });
    // }

    // Scroll and unhide logic (hide only main-content, not body)
    const contactSection = document.getElementById('contact');
    const mainContent = document.querySelector('.main-content');
    let shouldScroll = false;

    if (window.location.hash === "#contact") {
        shouldScroll = true;
    }
    if (sessionStorage.getItem('scrollToContact') === '1') {
        shouldScroll = true;
        sessionStorage.removeItem('scrollToContact');
    }
    if (contactSection && contactSection.classList.contains('hide-until-scrolled')) {
        shouldScroll = true;
    }
    if (contactSection && contactSection.querySelector('.alert-danger')) {
        shouldScroll = true;
        // Optionally focus first invalid field
        const firstInvalid = contactSection.querySelector('.is-invalid');
        if (firstInvalid) firstInvalid.focus();
    }

    function revealPage() {
        if (mainContent) mainContent.classList.remove('hide-until-scrolled');
        if (contactSection) contactSection.classList.remove('hide-until-scrolled');
    }

    if (shouldScroll && contactSection) {
        setTimeout(function () {
            const y = contactSection.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
            window.scrollTo({top: y, behavior: "instant"});
            revealPage();
        }, 25);
    } else {
        revealPage();
    }

    if (contactSection && isElementInViewport(contactSection)) {
        showRecaptchaBadge(true);
    } else {
        showRecaptchaBadge(false);
    }


    // Auto-dismiss confirmation message after 5 seconds
    const confirmation = document.getElementById('contact-confirmation');
    if (confirmation) {
        setTimeout(function() {
            confirmation.style.display = 'none';
        }, 5000);
    }
});

